import { faFlask, faLayerGroup, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import '../styles/solutions-styles.css'

function LoadSolutions() {
    
    return (
        <div className="container" id="solutions">
            <div>
                <h2>Applied AI for Real-World Impact</h2>
                <p>We turn complex problems into competitive advantages across industries.</p>
            </div>

            <div className='slider-container'>
                <div className='slide-group'>
                    <div className="card">
                        <div>
                            <h2>Agentic Al & Automation</h2>
                            <div>
                                <p>Our latest frontier. We design and build sophisticated Al agents that automate complex, multi-step workflows. These autonomous systems streamline operations, reduce human error, and free up your team to focus on strategic initiatives.</p>
                                <ul>
                                    <li>Bespoke Agentic Workflow Builders</li>
                                    <li>Multi-Agent Orchestration</li>
                                    <li>Intelligent Process Automation</li>
                                </ul>
                            </div>
                        </div>

                        <div>
                            <FontAwesomeIcon icon={faLayerGroup} />
                            <p>Automating end-to-end business processes.</p>
                        </div>
                    </div>

                    <div className="card">
                        <div>
                            <h2>Al for Retail & CPG</h2>
                            <div>
                                <p>We developed custom vision Al for a major US supermarket chain to revolutionize their point-of-sale operations. Our solutions enhance customer experience and provide critical business insights.</p>
                                <ul>
                                    <li>Automated identification of non-barcoded products</li>
                                    <li>Shrinkage and loss detection at checkout</li>
                                    <li>Generative Al for planogram compliance verification</li>
                                </ul>
                            </div>
                        </div>

                        <div>
                            <FontAwesomeIcon icon={faShoppingCart} />
                            <p>Optimizing in-store efficiency and accuracy.</p>
                        </div>
                    </div>

                    <div className="card">
                        <div>
                            <h2>Industrial & Scientific Al</h2>
                            <div>
                                <p>Our advanced image analysis engines tackle microscopic challenges, from manufacturing quality control to complex biomedical research, providing insights that are impossible to achieve manually.</p>
                                <ul>
                                    <li>Automated defect detection (e.g., macro voids in PCBs)</li>
                                    <li>Particle size analysis and super-resolution imaging</li>
                                    <li>Tracking cellular and muscular changes in biomedical imaging</li>
                                </ul>
                            </div>
                        </div>

                        <div>
                            <FontAwesomeIcon icon={faFlask} />
                            <p>Automating end-to-end business processes.</p>
                        </div>
                    </div>
                </div>

                <div className='slide-group'>
                    <div className="card">
                        <div>
                            <h2>Agentic Al & Automation</h2>
                            <div>
                                <p>Our latest frontier. We design and build sophisticated Al agents that automate complex, multi-step workflows. These autonomous systems streamline operations, reduce human error, and free up your team to focus on strategic initiatives.</p>
                                <ul>
                                    <li>Bespoke Agentic Workflow Builders</li>
                                    <li>Multi-Agent Orchestration</li>
                                    <li>Intelligent Process Automation</li>
                                </ul>
                            </div>
                        </div>

                        <div className="custom">
                            <FontAwesomeIcon icon={faLayerGroup} />
                            <p>Automating end-to-end business processes.</p>
                        </div>
                    </div>

                    <div className="card">
                        <div>
                            <h2>Al for Retail & CPG</h2>
                            <div>
                                <p>We developed custom vision Al for a major US supermarket chain to revolutionize their point-of-sale operations. Our solutions enhance customer experience and provide critical business insights.</p>
                                <ul>
                                    <li>Automated identification of non-barcoded products</li>
                                    <li>Shrinkage and loss detection at checkout</li>
                                    <li>Generative Al for planogram compliance verification</li>
                                </ul>
                            </div>
                        </div>

                        <div>
                            <FontAwesomeIcon icon={faShoppingCart} />
                            <p>Optimizing in-store efficiency and accuracy.</p>
                        </div>
                    </div>

                    <div className="card">
                        <div>
                            <h2>Industrial & Scientific Al</h2>
                            <div>
                                <p>Our advanced image analysis engines tackle microscopic challenges, from manufacturing quality control to complex biomedical research, providing insights that are impossible to achieve manually.</p>
                                <ul>
                                    <li>Automated defect detection (e.g., macro voids in PCBs)</li>
                                    <li>Particle size analysis and super-resolution imaging</li>
                                    <li>Tracking cellular and muscular changes in biomedical imaging</li>
                                </ul>
                            </div>
                        </div>

                        <div>
                            <FontAwesomeIcon icon={faFlask} />
                            <p>Automating end-to-end business processes.</p>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default LoadSolutions;